// @flow
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

export const FlexRowSpaceBetween = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

const FullWidthRatioContainer = styled.div`
    display: flex;
    width: 100%;
`
export const FullWidthRatio = ({ children, ratio = 4/5, style, ...props }: { children: any, style: any, ratio?: number }) => {
    const viewport = useRef(null);
    const [ height, setHeight ] = useState(0);

    const onWindowResize = () => {
        if (!viewport.current) {
            return;
        }
        setHeight(viewport.current.offsetWidth / ratio);
    }

    useEffect(() => {
        onWindowResize();
        window.addEventListener('resize', onWindowResize);
        return () => {
            window.removeEventListener('resize', onWindowResize)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ ratio ])

    return (
        <FullWidthRatioContainer
            {...props}
            ref={viewport}
            style={{
                ...style,
                ...(height === 0 ? {} : { height: height+ 'px' })
            }}
        >
                {children}
        </FullWidthRatioContainer>
    )
}